import React from "react";
import { SiPython } from "react-icons/si";

const PySdkPlaybox = () => {
  return (
    <div className="doc_page_cont">
      <p className="doc_page_cont_title">
        <SiPython /> Playbox
      </p>

      <p className="doc_page_cont_paragraph">
        The <strong>Erioon Playbox</strong> lets you execute Python code in isolated environments. It is designed for safe, remote computation such as data science tasks, ML training, and experimentation.
      </p>

      <SDKFunction
        id="playbox"
        title="Playbox Python SDK Usage"
        description={
          <>
            <p>
              The <strong>Playbox</strong> manages Python code execution inside isolated playboxes.
              When you call <code>runCode()</code>, it handles pod lifecycle, package installation,
              and code execution securely inside the pod.
            </p>

            <p><strong>Before you begin:</strong></p>
            <ol className="doc_list">
              <li>Log into your Erioon dashboard.</li>
              <li>Go to the <strong>Playbox</strong> section and create a new Playbox.</li>
              <li>Get the <code>play-id</code> for your newly created environment.</li>
              <li>Use your API key or Access credentials to authenticate.</li>
            </ol>

            <p><strong>runCode method:</strong></p>
            <ul className="doc_list">
              <li><code>runCode(code: str, packages?: str)</code> — runs your Python code.</li>
              <li><code>packages</code> is optional shell commands to install dependencies (e.g. <code>pip install numpy</code>).</li>
              <li>Returns the output as a Python dict parsed from the pod's stdout.</li>
              <li>Handles pod lifecycle transparently.</li>
            </ul>
          </>
        }
        code={`
from erioon.login import ErioonLogin

# Authenticate with your API key
API = "your-api-key"
session = ErioonLogin(API)

# Connect to an existing Playbox using its ID
playbox = session["play-id"]

# Python code you want to run
code = \"\"\"
print("Hello from Erioon playbox!")
\"\"\"

# Run the code and optionally install dependencies
output = playbox.runCode(code, "pip install <package-name-here>")
`}
      />
    </div>
  );
};

// Reusable documentation block with ID support
const SDKFunction = ({ id, title, description, code }) => (
  <div className="sdk_section" id={id}>
    <p className="doc_page_cont_subtitle">{title}</p>
    <div className="doc_page_cont_paragraph">{description}</div>
    <pre className="code_block_docs">{code}</pre>
  </div>
);

export default PySdkPlaybox;
